














































































































































































































































































import { Vue, Component } from 'vue-property-decorator';

import { fetchDevoluciones } from './fetchDevoluciones';
import ComponenteDialogoReporteTecnico from './ComponenteDialogoReporteTecnico.vue';

import ComponenteForm from './ComponenteForm.vue';

import { campos } from '@/pantallas/Conecta/Devoluciones/camposDevoluciones';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ValueFormatterParams,
  GetQuickFilterTextParams,
  RowNode,
} from 'ag-grid-community';

import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import BuscadorMantenedor from '@/reusable/Grid/BuscadorMantenedor.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModalCrear from '@/reusable/Modal/CabeceraModalCrear.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';

import { actionsEvent } from '@/setup';

import CabeceraModalDevolucionCrear from './CabeceraModalDevolucionCrear.vue';
import CabeceraModalDevolucionVista from './CabeceraModalDevolucionVista.vue';
import CabeceraModalDevolucionEditar from './CabeceraModalDevolucionEditar.vue';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';

@Component({
  components: {
    DatePicker,
    ModalMantenedor,
    CabeceraModalCrear,
    NavegacionModalCrud,
    CrudStepperHeader,
    CrudStepperItems,
    CrudStepperContent,
    ComponenteDialogoReporteTecnico,
    BuscadorMantenedor,
    MantenedorGridSinCodigo,
    CabeceraModalDevolucionCrear,
    CabeceraModalDevolucionVista,
    CabeceraModalDevolucionEditar,
    ComponenteForm,
    PopUpGeneratedReports,
  },
})
export default class Devoluciones extends Vue {
  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handleVer);
    actionsEvent.onEditar(this.handleEditar);
  }

  componenteFormulario: any;
  mounted() {
    this.tipoFecha = 'Fecha de Recepción';
    this.componenteFormulario = this.$refs.formulario;
    this.getNumerosSerie();
  }
  filtro: string = '';
  info: any = [];
  infoVisualizacion: any = [];
  infoEdicion: any = [];
  busqueda = '';
  objParaCrear: any = {};
  objParaEditar: any = {};
  objReporte: any = {};
  devoNume = '';
  devoNumeRTcr = '';
  devoNumeRTed = '';
  devoNumeRTver = '';

  tipoEquipo = '';
  coordinador = '';
  serienumero = '';
  tipoFecha: any;
  mostrarTipoFechaRecepcion = true;
  mostrarRepoTecnicos = false;
  fechaInicioRecepcion = moment().subtract(1, 'month');
  fechaFinRecepcion = moment();
  fechaInicioRegistro = moment().subtract(1, 'month');
  fechaFinRegistro = moment();

  tipoEquiposOptions: any = [];
  coordinadoresOptions: any = [];
  numerosSerieOptions: any = [];

  //cabecera modal crear//
  permitirGuardCrear = false;
  abrirModalCrear = false;
  pasoActivoIndexCrear = 1;
  abrirModalEditar = false;
  pasoActivoIndexEditar = 1;
  abrirModalVer = false;
  pasoActivoIndexVer = 1;
  mostrarBtnContinuarCrear = true;

  //cabecera modal ver//
  mostrarContinuarVer = true;
  mostrarVolverVer = false;

  //cabecera modal editar//
  permitirContinuarEditar = false;
  mostrarVolverEditar = false;
  mostrarBtnContinuarEditar = true;
  mostrarBtnGuardar = true;

  loadingService = new LoadingService();
  $snotify: any;

  showPopUpReport: boolean = false;
  msgReport: string = '';

  // tabla //
  gridApi: GridApi = null;
  enrichedGridOptions: GridOptions = null;
  readonly funcionalidad: Funcionalidades = Funcionalidades.Devoluciones;
  readonly gridOptions: GridOptions = {
    columnDefs: campos,
    onGridReady: this.handleGridReady,
    /* isExternalFilterPresent: this.isExternalFilterPresent,
    doesExternalFilterPass: this.doesExternalFilterPass, */
    paginationPageSize: 30,
    /* processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    }, */
  };
  async handleGridReady(event: GridReadyEvent) {
    await this.cargaInicialGrilla();
    this.gridApi = event.api;
  }
  /* fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  } */
  handleBusqueda(consulta: string) {
    this.busqueda = consulta.toLowerCase();
    this.gridApi.onFilterChanged();
  }
  doesExternalFilterPass(node: RowNode): boolean {
    if (this.info.length > 0 && this.busqueda.length > 0) {
      let search =
        node.data.devofecha_recepcion.toLowerCase().includes(this.busqueda) ||
        node.data.devofecha_alta.toLowerCase().includes(this.busqueda) ||
        node.data.devorequerimiento.toLowerCase().includes(this.busqueda) ||
        node.data.nombre_equipo.toLowerCase().includes(this.busqueda) ||
        node.data.serienumero.toLowerCase().includes(this.busqueda) ||
        node.data.nombre_coordinador.toLowerCase().includes(this.busqueda) ||
        node.data.devonumero.toLowerCase().includes(this.busqueda) ||
        node.data.configvalor.toLowerCase().includes(this.busqueda) ||
        node.data.simserienumero.toLowerCase().includes(this.busqueda) ||
        node.data.devoanuladesc.toLowerCase().includes(this.busqueda) ||
        node.data.registrada.toLowerCase().includes(this.busqueda);
      return search;
    }
    return true;
  }
  isExternalFilterPresent(): boolean {
    return true;
  }
  // fin tabla //

  // cabecera modal custom CREAR //
  cerrarModalCrear() {
    this.abrirModalCrear = false;
    this.pasoActivoIndexCrear = 1;
    this.permitirGuardCrear = false;
    this.mostrarBtnContinuarCrear = true;
    this.infoVisualizacion = [];
    this.cargaInicialGrilla();
  }
  ocultarGuardar() {
    this.permitirGuardCrear = false;
  }
  // fin cabecera modal custom CREAR //

  // cabecera modal custom VER //
  cerrarModalVer() {
    this.pasoActivoIndexVer = 1;
    this.mostrarContinuarVer = true;
    this.mostrarVolverVer = false;
    this.abrirModalVer = false;
  }
  continuarVer() {
    this.pasoActivoIndexVer = 2;
    this.mostrarContinuarVer = false;
    this.mostrarVolverVer = true;
  }
  volverVer() {
    this.pasoActivoIndexVer = 1;
    this.mostrarContinuarVer = true;
    this.mostrarVolverVer = false;
  }
  // fin cabecera modal custom VER //

  // cabecera modal custom EDITAR //
  cerrarModalEditar() {
    this.pasoActivoIndexEditar = 1;
    this.permitirContinuarEditar = false;
    this.mostrarVolverEditar = false;
    this.mostrarBtnContinuarEditar = true;
    this.mostrarBtnGuardar = true;
    this.abrirModalEditar = false;
    this.infoVisualizacion = [];
    this.cargaInicialGrilla();
  }
  continuarEditar(evento: any) {
    this.pasoActivoIndexEditar = 2;
    this.mostrarVolverEditar = true;
    this.mostrarBtnContinuarEditar = false;
  }

  volverEditar() {
    this.pasoActivoIndexEditar = 1;
    this.mostrarVolverEditar = false;
    this.mostrarBtnContinuarEditar = true;
    this.permitirContinuarEditar = false;
  }
  // fin cabecera modal custom EDITAR //

  objsParaAlta(obj: any) {
    if (obj.step === 1) {
      this.objParaCrear = obj;
      this.objParaCrear.moduloID = Funcionalidades.Devoluciones;
    }
    if (
      this.objParaCrear.equipoSerieNumero != '' &&
      this.objParaCrear.requerimiento != '' &&
      this.objParaCrear.coordinadorID != '' &&
      this.objParaCrear.serieActivaNRO != '(Sin Datos)' &&
      this.objParaCrear.fechaAlta &&
      this.objParaCrear.fechaBaja &&
      this.objParaCrear.userID &&
      this.objParaCrear.userRUT &&
      this.objParaCrear.fechaRecepcion != '' &&
      this.objParaCrear.equipoID != 0
    ) {
      this.permitirGuardCrear = true;
    }
  }

  async handleGuardar() {
    if (this.objParaCrear.hasOwnProperty('equipoSerieNumero')) {
      this.loadingService.showLoading(undefined, 'handleGuardar');
      this.devoNume = await fetchDevoluciones(
        'ingresarDevolucion',
        this.objParaCrear
      )
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
            this.devoNumeRTcr = data.data.devoNum;
            this.mostrarRepoTecnicos = true;
            this.pasoActivoIndexCrear = 2;
            this.mostrarBtnContinuarCrear = false;
            return data.data.devoNum;
          } else {
            this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
            this.abrirModalCrear = false;
            this.mostrarRepoTecnicos = false;
            this.pasoActivoIndexCrear = 1;
            this.permitirGuardCrear = false;
            this.mostrarBtnContinuarCrear = true;
          }
          return 0;
        })
        .catch((err: any) => console.error(err))
        .finally(() => this.loadingService.hideLoading('handleGuardar'));
    } else return true;
  }

  objEditCabecera(obj: any) {
    this.objParaEditar = obj;
    this.objParaEditar.moduloId = Funcionalidades.Devoluciones;
    if (this.objParaEditar) this.permitirContinuarEditar = true;
  }

  cambiarTipoFecha() {
    if (this.tipoFecha.tipo == 1) {
      this.mostrarTipoFechaRecepcion = true;
      this.fechaInicioRecepcion = moment().subtract(1, 'month');
      this.fechaFinRecepcion = moment();
      this.fechaInicioRegistro = moment().subtract(1, 'month');
      this.fechaFinRegistro = moment();
    }
    if (this.tipoFecha.tipo == 2) {
      this.mostrarTipoFechaRecepcion = false;
      this.fechaInicioRecepcion = moment().subtract(1, 'month');
      this.fechaFinRecepcion = moment();
      this.fechaInicioRegistro = moment().subtract(1, 'month');
      this.fechaFinRegistro = moment();
    }
  }

  cargaInicialGrilla() {
    this.loadingService.showLoading();
    return fetchDevoluciones('getDevoluciones', { '': '' })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.info = data.data.data;
          /* for (let i in this.info) {
            this.info[i].devoanula == ''
              ? (this.info[i].devoanuladesc = '🟢 VIGENTE')
              : (this.info[i].devoanuladesc = '🔴 ANULADO');

            this.info[i].serieactivaplata_ingresada == 'S'
              ? (this.info[i].registrada = 'SÍ')
              : (this.info[i].registrada = 'NO');
          } */
          if (data.data.data.STATUS === 'SIN_DATA') {
            this.info = [];
            this.$snotify.warning('Sin registros. Verifique sus filtros', {
              timeout: 3000,
            });
          }
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.info = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.loadingService.hideLoading('cargaInicialGrilla');
        this.nombresEquiposPorIds();
      });
  }

  getTipoEquipos() {
    this.loadingService.showLoading(undefined, 'getTipoEquipos');
    return fetchDevoluciones('getTipoEquipos', { '': '' })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          if (data.data.data.hasOwnProperty('LISTA'))
            this.tipoEquiposOptions = data.data.data.LISTA;
          else this.tipoEquiposOptions = [data.data.data];
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.tipoEquiposOptions = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getTipoEquipos'));
  }

  getCoordinadores() {
    this.loadingService.showLoading(undefined, 'getCoordinadores');
    return fetchDevoluciones('getCoordinadores', { '': '' })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          if (data.data.data.hasOwnProperty('LISTA'))
            this.coordinadoresOptions = data.data.data.LISTA;
          else this.coordinadoresOptions = [data.data.data];
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.coordinadoresOptions = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getCoordinadores'));
  }

  async nombresEquiposPorIds() {
    await this.getTipoEquipos();

    /* for (let i in this.info) {
      let nameTE = '';
      this.tipoEquiposOptions.forEach((eq: any) => {
        if (eq.tipoeqid == this.info[i].tipoeqid) nameTE = eq.tipoeqname;
      });
      this.info[i].nombre_equipo = nameTE;
    } */
    this.nombresCoordinadorPorIds();
  }

  async nombresCoordinadorPorIds() {
    await this.getCoordinadores();
    /* for (let i in this.info) {
      let nameC = '';
      this.coordinadoresOptions.forEach((c: any) => {
        if (c.coorid == this.info[i].coorid) nameC = c.coorname;
      });
      this.info[i].nombre_coordinador = nameC;
    } */
    this.gridApi.setRowData(this.info);
    this.gridApi.setDomLayout('autoHeight');
  }

  getNumerosSerie() {
    this.loadingService.showLoading(undefined, 'getNumerosSerie');
    return fetchDevoluciones('getNumerosSerie', { '': '' })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.numerosSerieOptions = data.data.data;
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.numerosSerieOptions = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getNumerosSerie'));
  }

  readonly pasosCrear: PasosCrud = {
    devolucion: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Crear Devolución a Bodega Operaciones',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
    crearReporte: {
      accion: '',
      visible: true,
      step: 2,
      title: 'Crear Reportes Técnicos a Bodega Operaciones',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
  };

  readonly pasosEditar: PasosCrud = {
    editarDevolucion: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Editar Devolución a Bodega Operaciones',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
    crearReporte: {
      accion: '',
      visible: true,
      step: 2,
      title: 'Crear y Editar Reportes Técnicos a Bodega Operaciones',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
  };

  readonly pasosVer: PasosCrud = {
    verDevolucion: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Ver Devolución a Bodega Operaciones',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
    verReporte: {
      accion: '',
      visible: true,
      step: 2,
      title: 'Ver Reporte Técnico',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
  };

  handleBuscar() {
    this.loadingService.showLoading();
    let body = {
      fechaInicio: moment(),
      fechaFin: moment(),
      tipoFecha: 1,
      tipoEquipo: this.tipoEquipo || '',
      coordinador: this.coordinador || '',
      serieNumero: this.serienumero || '',
    };
    if (this.tipoFecha == 'Fecha de Recepción') {
      body.fechaInicio = this.fechaInicioRecepcion;
      body.fechaFin = this.fechaFinRecepcion;
      body.tipoFecha = 1;
    } else if (this.tipoFecha.tipo == 1) {
      body.fechaInicio = this.fechaInicioRecepcion;
      body.fechaFin = this.fechaFinRecepcion;
      body.tipoFecha = 1;
    } else if (this.tipoFecha.tipo == 2) {
      body.fechaInicio = this.fechaInicioRegistro;
      body.fechaFin = this.fechaFinRegistro;
      body.tipoFecha = 2;
    }
    return fetchDevoluciones('getDevoluciones', body)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.info = data.data.data;
          /* for (let i in this.info) {
            this.info[i].devoanula == ''
              ? (this.info[i].devoanuladesc = '🟢 VIGENTE')
              : (this.info[i].devoanuladesc = '🔴 ANULADO');

            this.info[i].serieactivaplata_ingresada == 'S'
              ? (this.info[i].registrada = 'SÍ')
              : (this.info[i].registrada = 'NO');
          } */
          if (data.data.data.STATUS === 'SIN_DATA') {
            this.info = [];
            this.$snotify.warning('Sin registros. Verifique sus filtros', {
              timeout: 3000,
            });
          }
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.info = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.loadingService.hideLoading();
        this.gridApi.setRowData(this.info);
        this.gridApi.setDomLayout('autoHeight');
        this.nombresEquiposPorIds();
      });
  }

  handleEditar(e: any) {
    this.infoEdicion = [];
    this.devoNumeRTed = '';
    this.infoEdicion.push(e.data);
    this.devoNumeRTed = e.data.devonumero;
    this.abrirModalEditar = true;
  }

  handleVer(e: any) {
    this.infoVisualizacion = [];
    this.devoNumeRTver = '';
    this.infoVisualizacion.push(e.data);
    this.devoNumeRTver = e.data.devonumero;
    this.abrirModalVer = true;
  }

  clearFilters() {
    this.tipoEquipo = '';
    this.coordinador = '';
    this.serienumero = '';
    this.tipoFecha = 'Fecha de Recepción';
    this.mostrarTipoFechaRecepcion = true;
    this.fechaInicioRecepcion = moment().subtract(1, 'month');
    this.fechaFinRecepcion = moment();
    this.fechaInicioRegistro = moment().subtract(1, 'month');
    this.fechaFinRegistro = moment();
    this.cargaInicialGrilla();
  }

  get estadoIdCrear() {
    const { entity } = this.pasosCrear.devolucion.formState;
    if (!entity) return null;
    return entity.estado;
  }

  get estadoIdEditar() {
    const { entity } = this.pasosEditar.editarDevolucion.formState;
    if (!entity) return null;
    return entity.estado;
  }

  get estadoIdVer() {
    const { entity } = this.pasosVer.verDevolucion.formState;
    if (!entity) return null;
    return entity.estado;
  }

  get fechaMaxima() {
    const hoy = new Date();
    let fechaMax =
      hoy.getFullYear() +
      '-' +
      this.dosCifras((hoy.getMonth() + 1).toString()) +
      '-' +
      this.dosCifras(hoy.getDate().toString());
    return fechaMax;
  }

  dosCifras(valor: string) {
    return valor.length == 1 ? '0' + valor : valor;
  }

  findFilter({ paramsApi, list, id, propName }: any): string {
    const obj = list.find((item: any) => item[id] === paramsApi[id]);
    return obj ? obj[propName] : '';
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  async getCSV(): Promise<void> {
    const paramsApi: any = {
      coorid: this.coordinador || '',
      tipoeqid: this.tipoEquipo || '',
      serieNumero: this.serienumero || '',
      fechaInicioRecepcion: this.fechaInicioRecepcion,
      fechaFinRecepcion: this.fechaFinRecepcion,
      fechaInicioRegistro: this.fechaInicioRegistro,
      fechaFinRegistro: this.fechaFinRegistro,
      tipoFecha: this.tipoFecha,
    };

    const findItem: Record<string, string[]> = {
      tipoeqid: [this.tipoEquiposOptions, 'tipoeqid', 'tipoeqname'],
      coorid: [this.coordinadoresOptions, 'coorid', 'coorname'],
    };

    const filter: Record<string, string> = {};

    for (const category in findItem) {
      if (paramsApi.hasOwnProperty(category) && paramsApi[category]) {
        const [list, id, propName] = findItem[category];
        filter[propName] = this.findFilter({
          paramsApi,
          list,
          id,
          propName,
        });
      }
    }

    const user = localStorage.getItem('user');
    const userId = JSON.parse(user.replace(/'/g, '"')).id;
    const clienteDefecto = localStorage.getItem('clienteDefecto');
    this.loadingService.showLoading();
    const self = this;

    return await fetchDevoluciones('export_excel', {
      userId,
      clienteDefecto,
      ...paramsApi,
      ...filter,
    })
      .then((response: any) => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return;
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3500 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
}
